/** Where Email Students lives, for a class's public id. */
export const emailStudentsRoute = '/notifications/classes/:classId/email-students'

export function emailStudentsPath(classId: string): string {
  return `/notifications/classes/${encodeURIComponent(classId)}/email-students`
}

/** Classes' permission to see a class's roster, which Email Students needs, as legacy's did. */
export const readClassRosterPermission = 'classes.class-roster.read'

/** The API's endpoint for a message to a class's learners. */
export function classMessagesApi(classId: string): string {
  return `/notifications/v1/classes/${encodeURIComponent(classId)}/messages`
}
